import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import ArabicHeader from './arabic/ArabicHeader';
import ArabicFooter from './arabic/ArabicFooter';
import FAQ from '../pages/FAQ';

import Home from '../pages/Home';
import WebsiteExample from '../pages/WebsiteExample';
import Partnership from '../pages/Partnership';
import AIProjectHelp from '../pages/AIProjectHelp';
import Portfolio from '../pages/Portfolio';
import Contact from '../pages/Contact';
import PrivacyRemovalClean from '../pages/PrivacyRemovalClean';
import Integritetspolicy from '../pages/Integritetspolicy';
import Användarvillkor from '../pages/Användarvillkor';
import CookiesPolicy from '../pages/CookiesPolicy';
import SnapHandoverLegal from '../pages/SnapHandoverLegal';
import IndustrySeoHub from '../pages/IndustrySeoHub';
import IndustrySeoLanding from '../pages/IndustrySeoLanding';
import ArabicHome from '../pages/arabic/ArabicHome';
import ArabicBusinessWebsite from '../pages/arabic/ArabicBusinessWebsite';
import ArabicPricing from '../pages/arabic/ArabicPricing';
import ArabicContact from '../pages/arabic/ArabicContact';

const SNAP_HANDOVER_LEGAL_PATHS = new Set([
  '/snaphandover-privacy',
  '/legal/snaphandover/privacy',
  '/legal/snaphandover/terms',
]);

function SiteContent() {
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/+$/, '') || '/';
  const isArabicPath = normalizedPath === '/ar' || normalizedPath.startsWith('/ar/');

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (location.hash) {
        try { document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView(); } catch (_) { window.scrollTo(0, 0); }
      } else { window.scrollTo(0, 0); }
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <div className="App min-h-screen bg-white">
      <a className="skip-link" href="#main-content">{isArabicPath ? 'انتقل إلى المحتوى' : 'Hoppa till innehållet'}</a>
      {isArabicPath ? <ArabicHeader /> : <Header />}
      <main id="main-content" className="pt-[76px]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/exempel/stadfirma" element={<WebsiteExample />} />
          <Route path="/samarbete" element={<Partnership />} />
          <Route path="/pricing" element={<Navigate to="/#pris" replace />} />
          <Route path="/priser" element={<Navigate to="/#pris" replace />} />
          <Route path="/ai-projekt" element={<AIProjectHelp />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/integritetspolicy" element={<Integritetspolicy />} />
          <Route path="/användarvillkor" element={<Användarvillkor />} />
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
          <Route path="/faq" element={<FAQ />} />

          <Route path="/ta-bort-personuppgifter" element={<PrivacyRemovalClean language="sv" />} />
          <Route path="/en/remove-personal-data" element={<PrivacyRemovalClean language="en" />} />
          <Route path="/fr/supprimer-donnees-personnelles" element={<PrivacyRemovalClean language="fr" />} />
          <Route path="/ar/remove-personal-data" element={<PrivacyRemovalClean language="ar" />} />

          <Route path="/hemsidor-for-smaforetag" element={<IndustrySeoHub language="sv" />} />
          <Route path="/hemsida-stadfirma" element={<IndustrySeoLanding industry="cleaning" language="sv" />} />
          <Route path="/hemsida-flyttfirma" element={<IndustrySeoLanding industry="moving" language="sv" />} />
          <Route path="/hemsida-hantverkare" element={<IndustrySeoLanding industry="crafts" language="sv" />} />
          <Route path="/hemsida-frisor-salong" element={<IndustrySeoLanding industry="salon" language="sv" />} />
          <Route path="/hemsida-restaurang" element={<IndustrySeoLanding industry="restaurant" language="sv" />} />

          <Route path="/ar" element={<ArabicHome />} />
          <Route path="/ar/hemsidor-for-smaforetag" element={<IndustrySeoHub language="ar" />} />
          <Route path="/ar/hemsida-stadfirma" element={<ArabicBusinessWebsite type="cleaning" />} />
          <Route path="/ar/hemsida-flyttfirma" element={<ArabicBusinessWebsite type="moving" />} />
          <Route path="/ar/hemsida-hantverkare" element={<IndustrySeoLanding industry="crafts" language="ar" />} />
          <Route path="/ar/hemsida-frisor-salong" element={<IndustrySeoLanding industry="salon" language="ar" />} />
          <Route path="/ar/hemsida-restaurang" element={<IndustrySeoLanding industry="restaurant" language="ar" />} />
          <Route path="/ar/priser" element={<ArabicPricing />} />
          <Route path="/ar/kontakt" element={<ArabicContact />} />

          <Route path="*" element={<Navigate to={isArabicPath ? '/ar' : '/'} replace />} />
        </Routes>
      </main>
      {isArabicPath ? <ArabicFooter /> : <Footer />}
    </div>
  );
}

function App() {
  const pathname = typeof window !== 'undefined'
    ? window.location.pathname.replace(/\/+$/, '') || '/'
    : '/';

  if (SNAP_HANDOVER_LEGAL_PATHS.has(pathname)) {
    return (
      <HelmetProvider>
        <SnapHandoverLegal />
      </HelmetProvider>
    );
  }

  return (
    <HelmetProvider>
      <Router>
        <SiteContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
